export default __webpack_public_path__ + "images/69483a6795b18c6d44143f9a6399142c-valentine_dating_desktop.webp";